
export const RENTAL_SERVICE_SLUG_FOR_NEAREST_BRANCH = 'heavy-equipment-rental';

export const GOOGLE_MAP_BASE_URL = 'https://www.google.com/maps';

export const US_CENTER_LATITUDE = '39.8283';
export const US_CENTER_LONGITUDE = '-98.5795';
